module.exports = __webpack_public_path__ + "static/media/emery.e377c12d.jpg";